import { Schema } from "effect";

/**
 * Schema for CustomerInfo with validation rules
 */
export const CustomerInfoSchema = Schema.Struct({
  firstName: Schema.String.pipe(Schema.nonEmptyString()),
  lastName: Schema.String.pipe(Schema.nonEmptyString()),
  street: Schema.String.pipe(Schema.nonEmptyString()),
  zip: Schema.String.pipe(Schema.nonEmptyString()),
  city: Schema.String.pipe(Schema.nonEmptyString()),
  country: Schema.String.pipe(Schema.nonEmptyString()),
  email: Schema.String.pipe(
    Schema.nonEmptyString(),
    Schema.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
      message: () => "Invalid email format",
    })
  ),
  phone: Schema.optional(Schema.String.pipe(Schema.nonEmptyString())),
});

/**
 * CustomerInfo value object representing customer data snapshot at invoice creation time.
 * This ensures immutability and captures customer information as it was when the invoice was created.
 */
export type CustomerInfo = Schema.Schema.Type<typeof CustomerInfoSchema>;

/**
 * Factory function to create and validate CustomerInfo
 */
export const createCustomerInfo = (
  data: unknown
): Schema.Schema.Encoded<typeof CustomerInfoSchema> =>
  Schema.decodeUnknownSync(CustomerInfoSchema)(data);

/**
 * Validation function that returns an Effect
 */
export const validateCustomerInfo = (data: unknown) =>
  Schema.decodeUnknown(CustomerInfoSchema)(data);
